export default __webpack_public_path__ + "static/media/tuome.b9d45765.jpeg";